import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await authAPI.getCurrentUser();
          setUser(response.data);
        } catch (error) {
          console.error('Auth init error:', error);
          // Nettoyer le localStorage en cas d'erreur (token expiré, etc.)
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    try {
      // Nettoyer les anciennes données avant de se connecter
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      const response = await authAPI.login({ email, password });
      const { token, gestionnaire } = response.data;
      
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(gestionnaire));
      setUser(gestionnaire);
      
      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      // S'assurer que le localStorage est nettoyé en cas d'erreur
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Email ou mot de passe incorrect' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login';
  };

  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user,
    isSuperAdmin: user?.role === 'super_admin',
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
